import { useCallback } from 'react';
import usePatchProspectAccount from 'hooks/services/prospect/usePatchProspectAccount';
import CompanySearchModal from 'components/CompanySearchModal';
import { Account } from 'crono-fe-common/types/account';
import { AccountLinkedin } from 'crono-fe-common/types/accountLinkedin';
import { withMeta } from 'crono-fe-common/types/mutationMeta';
import { useAfterContactReassigned } from 'pages/accountDrawer/hooks/useAfterContactReassigned';

interface CompanyAssignModalProps {
  prospectId: string;
  close: () => void;
  openCreateCompany: (searchValue?: string) => void;
}

const CompanyAssignModal = ({
  prospectId,
  close,
  openCreateCompany,
}: CompanyAssignModalProps) => {
  const afterContactReassigned = useAfterContactReassigned();

  const { mutate: patchProspectAccount, isLoading: patchProspectLoading } =
    usePatchProspectAccount();

  const handleAssignNewCompany = useCallback(
    (account: Account | AccountLinkedin) => {
      patchProspectAccount(
        withMeta(
          { prospectId, accountId: account.objectId },
          {
            successMessage: `Contact linked to ${account.name} — strategy and tasks stopped`,
            errorMessage: 'Error while updating contact',
          },
        ),
        {
          onSuccess: () => {
            afterContactReassigned(account.objectId);
            close();
          },
        },
      );
    },
    [patchProspectAccount, prospectId, afterContactReassigned, close],
  );

  return (
    <CompanySearchModal
      title="Choose contact’s company:"
      submitButtonText="Assign"
      isSubmitting={patchProspectLoading}
      submit={handleAssignNewCompany}
      close={close}
      openCreateCompany={openCreateCompany}
    />
  );
};

export default CompanyAssignModal;
